/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener('DOMContentLoaded', function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min
  }

  let endTimeG

  function cutDownTime() {
    let nowTime = new Date()
    let endTime = new Date(endTimeG)

    let leftTime = endTime.getTime() - nowTime.getTime()
    if (leftTime < 0) {
      setupNewCountdown()
      leftTime = 0
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60)
    leftH = leftH >= 10 ? leftH : '0' + leftH
    leftM = leftM >= 10 ? leftM : '0' + leftM
    leftS = leftS >= 10 ? leftS : '0' + leftS

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    }
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9)
    const currentTime = new Date()
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
  }
  let intervalId

  function getCutDownTime() {
    setupNewCountdown()
    if (intervalId) clearInterval(intervalId)
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime()
      $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
      $('.sp_top_cut_down .sp_left_view .sp_minute').html(
        cutDownTimeText.minute
      )
      $('.sp_top_cut_down .sp_left_view .sp_second').html(
        cutDownTimeText.second
      )
    }, 1000)
  }

  getCutDownTime()

  new WOW().init()

  let spImgList = []

  jQuery('.sp-scroll2').slide({
    mainCell: '.nav-imgs',
    autoPlay: true,
    effect: 'leftMarquee',
    interTime: 12,
    vis: 1,
    scroll: 1,
  })

  new Swiper('.sp-swiper2', {
    speed: 5000,
    autoplay: true,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    loop: true,
  })

  new Swiper('.sp-swiper3', {
    autoplay: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    pagination: {
      el: '.sp-pagination',
      clickable: true,
    },
  })

  new Swiper('.sp-swiper-fade', {
    spaceBetween: 10,
    effect: 'fade',
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 2000,
    },
    speed: 2000,
  })

  new Swiper('.sp-swiper-fade1', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 10,
    loop: true,
    on: {
      slideChange: function (e) {
        e.slides.find('.sp-text').each(function () {
          this.style.animation = 'none'
        })
        const spText = e.slides.eq(e.activeIndex).find('.sp-text')[0]
        if (spText) {
          spText.style.animation = 'none'

          spText.style.animation = `swiper-up-fade 0.5s ease forwards`
        }
      },
    },
  })

  new Swiper('.sp-swiper0', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 10,
    loop: true,
    pagination: {
      el: '.sp-pagination1',
      clickable: true,
    },
  })

  // PC端第三板块轮播
  new Swiper('.sp-pt3-swiper', {
    slidesPerView: 'auto',
    spaceBetween: 50,
    centeredSlides: true,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    speed: 800,
  })

  // 移动端第三板块轮播
  new Swiper('.sp-pt3-mobile-swiper', {
    slidesPerView: 'auto',
    spaceBetween: 30,
    centeredSlides: true,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    speed: 800,
  })

  // 移动端第五板块步骤轮播
  new Swiper('.sp-part5-mobile .sp-step-swiper', {
    slidesPerView: 'auto',
    spaceBetween: 30,
    centeredSlides: true,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    speed: 800,
  })

  // FAQ展开收起功能
  $('.sp-faq-pc .sp-faq-question, .sp-faq-mobile .sp-faq-question').on(
    'click',
    function () {
      var $item = $(this).closest('.sp-faq-item')
      var $toggleBtn = $(this).find('.sp-toggle-btn span')

      if ($item.hasClass('active')) {
        $item.removeClass('active')
        $toggleBtn.text('+')
      } else {
        $item.addClass('active')
        $toggleBtn.text('-')
      }
    }
  )

  function mainRender() {
    $(function () {
      $('#root').css('zoom', 'normal')
      if (document.body.clientWidth <= 1060) {
        let scale = document.body.clientWidth / 1080
        $('#root').css('zoom', scale)
      } else {
        const scale = document.body.clientWidth / 1920
        $('#root').css('zoom', scale)
      }

      window.addEventListener(
        'resize',
        (function () {
          var timer
          return function () {
            if (timer) clearTimeout(timer)
            timer = setTimeout(function () {
              $('#root').css('zoom', 'normal')
              if (document.body.clientWidth <= 1060) {
                let scale = document.body.clientWidth / 1080
                $('#root').css('zoom', scale)
              } else {
                const scale = document.body.clientWidth / 1920
                $('#root').css('zoom', scale)
              }
            }, 100)
          }
        })()
      )
    })

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
      const config = {
        rootMargin: '0px 0px 1300px 0px',
        threshold: 0,
      }

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target
            const dataSrc = image.getAttribute('data-src')
            image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image) // 停止观察该图片
          }
        })
      },
      config)

      images.forEach(function (image) {
        lazyLoadObserver.observe(image) // 开始观察每个图片
      })
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach(subArray => {
          subArray.forEach(url => {
            const img = new Image()
            img.src = url
          })
        })
      } else {
        // 处理一维数组
        imageArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      }
    }

    lazyLoadImages()

    // preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop =
          document.body.clientWidth <= 1080
            ? targetElement.offsetTop - $('.sp-nav').height()
            : targetElement.offsetTop

        let sptop = document.body.clientWidth <= 1080 ? 180 : 94
        // let sptop = 0;

        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            sptop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        })
      })
    })

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera
    var isAndroid = /android/i.test(userAgent)
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log('Android')
    } else if (isIOS) {
      console.log('iOS')
    } else if (isPC) {
      console.log('PC')
    } else {
      $('.sp_system').css('letter-spacing', '-4px')
    }
  }

  mainRender()

  // 旧的价格计算代码已移除，使用新的initMobileProductCalc和initPCProductCalc

  $('.sp-pc .product-box').click(function () {
    $(this).addClass('sp-active').siblings().removeClass('sp-active')
  })

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName('gradually')
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll('span')
    const paragraph = gradually.querySelector('.sp-sub-title')

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`
              span.style.animationDelay = `${index * 0.1}s`

              const i = span.querySelector('i')
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`
                i.style.animationDelay = `${index * 0.1}s`
              }
            })

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`
              paragraph.style.animationDelay = `${totalDelay}s`
            }

            observer.unobserve(gradually)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observer.observe(gradually)
  }

  // // 点击按钮
  // $(".sp-video-btn").click(function () {
  //   $(".sp-mask").css("display", "flex");
  // });

  // 菜单
  $('.sp-menu-btn').click(function (e) {
    $('.sp-menu-mask').show()
  })

  $('.sp-menu-mask').click(function (e) {
    // if ($(e.target).closest(".sp-menu-mask li").length > 0) {
    // } else {
    $('.sp-menu-mask').hide()
    // }
  })

  // // 滚动隐藏顶部
  // if (
  //   $(window).scrollTop() >
  //   $(".sp-header").height() * $("div#root").css("zoom")
  // ) {
  //   $(".header-wrap").addClass("sp-fixed");
  // } else {
  //   $(".header-wrap").removeClass("sp-fixed");
  // }

  // // 滚动添加底部
  // if (
  //   $(window).scrollTop() >
  //   $(".sp-part1").height() * $("div#root").css("zoom") -
  //     $(".sp-part1 .swiper").height() * $("div#root").css("zoom")
  // ) {
  //   $(".sp-btn-style2").addClass("sp-fixed-bottom");
  // } else {
  //   $(".sp-btn-style2").removeClass("sp-fixed-bottom");
  // }

  $(window).scroll(function () {
    // if (
    //   $(window).scrollTop() >
    //   $(".sp-header").height() * $("div#root").css("zoom")
    // ) {
    //   $(".header-wrap").addClass("sp-fixed");
    // } else {
    //   $(".header-wrap").removeClass("sp-fixed");
    // }
    // if (
    //   $(window).scrollTop() >
    //   $(".sp-part1").height() * $("div#root").css("zoom") -
    //     $(".sp-part1 .swiper").height() * $("div#root").css("zoom")
    // ) {
    //   $(".sp-btn-style2").addClass("sp-fixed-bottom");
    // } else {
    //   $(".sp-btn-style2").removeClass("sp-fixed-bottom");
    // }
  })

  // 问答
  $('.q-row').click(function () {
    $(this).parent().toggleClass('sp-show')
  })

  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName('sp-fade-box')
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll('.sp-ani')

    const observerAni = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`
              span.style.animationDelay = `${index * 0.5 + 0.5}s`
            })

            observerAni.unobserve(gradually2)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAni.observe(gradually2)
  }
  // 文本渐出动画
  const graduallyList3 = document.getElementsByClassName('sp-fade-box2')
  for (let gradually3 of graduallyList3) {
    const paragraph3 = gradually3.querySelectorAll('.sp-ani2')

    const observerAni = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            paragraph3.forEach((span, index) => {
              span.style.animation = `sp-fade-left 1s ease forwards`
              span.style.animationDelay = `${index * 0.3 + 1}s`
            })

            observerAni.unobserve(gradually3)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAni.observe(gradually3)
  }

  // sp-part2 无缝轮播图功能
  function initPart2SwiperSeamless(selector, slideWidth) {
    const container = document.querySelector(selector)
    if (!container) return

    const wrapper = container.querySelector('.sp-swiper-wrapper')
    if (!wrapper) return

    // 获取或创建inner容器
    let inner = wrapper.querySelector('.sp-swiper-inner')
    if (!inner) {
      inner = document.createElement('div')
      inner.className = 'sp-swiper-inner'
      inner.style.display = 'flex'
      inner.style.transition = 'transform 0.5s ease'
      while (wrapper.firstChild) {
        inner.appendChild(wrapper.firstChild)
      }
      wrapper.appendChild(inner)
    }

    const slides = inner.querySelectorAll('.sp-swiper-slide')
    if (slides.length === 0) return

    const totalSlides = slides.length
    const prevBtn = container.querySelector('.sp-prev')
    const nextBtn = container.querySelector('.sp-next')

    // 克隆首尾slide实现无缝循环
    const firstClone = slides[0].cloneNode(true)
    const lastClone = slides[totalSlides - 1].cloneNode(true)
    firstClone.classList.add('clone')
    lastClone.classList.add('clone')
    inner.appendChild(firstClone)
    inner.insertBefore(lastClone, slides[0])

    let currentIndex = 1 // 从第一张真实slide开始（索引1，因为前面有克隆）
    let isTransitioning = false

    // 初始位置
    inner.style.transform = `translateX(-${currentIndex * slideWidth}px)`

    // 切换到指定索引
    function goToSlide(index) {
      if (isTransitioning) return
      isTransitioning = true
      currentIndex = index
      inner.style.transition = 'transform 0.5s ease'
      inner.style.transform = `translateX(-${currentIndex * slideWidth}px)`
    }

    // 过渡结束后检查是否需要无感跳转
    inner.addEventListener('transitionend', function () {
      isTransitioning = false
      // 如果到了克隆的最后一张（第一张的克隆），跳到真实的第一张
      if (currentIndex === totalSlides + 1) {
        inner.style.transition = 'none'
        currentIndex = 1
        inner.style.transform = `translateX(-${currentIndex * slideWidth}px)`
      }
      // 如果到了克隆的第一张（最后一张的克隆），跳到真实的最后一张
      if (currentIndex === 0) {
        inner.style.transition = 'none'
        currentIndex = totalSlides
        inner.style.transform = `translateX(-${currentIndex * slideWidth}px)`
      }
    })

    // 上一张
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goToSlide(currentIndex - 1)
      })
    }

    // 下一张
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goToSlide(currentIndex + 1)
      })
    }

    // 自动轮播
    let autoplayInterval = setInterval(function () {
      goToSlide(currentIndex + 1)
    }, 3000)

    // 鼠标悬停暂停自动轮播
    container.addEventListener('mouseenter', function () {
      clearInterval(autoplayInterval)
    })

    // 鼠标离开恢复自动轮播
    container.addEventListener('mouseleave', function () {
      autoplayInterval = setInterval(function () {
        goToSlide(currentIndex + 1)
      }, 3000)
    })
  }

  // 初始化PC端轮播图（宽度660px）
  initPart2SwiperSeamless('.sp-part2.sp-pc', 660)
  // 初始化移动端轮播图（宽度779px）
  initPart2SwiperSeamless('.sp-part2.sp-mobile', 779)

  // sp-part2-2 走马灯轮播图（中间完整+左右显示部分）
  function initPart2_2Swiper() {
    const container = document.querySelector('.sp-part2-2.sp-pc .sp-swiper-box')
    if (!container) return

    const wrapper = container.querySelector('.sp-swiper-wrapper')
    const inner = wrapper.querySelector('.sp-swiper-inner')
    if (!inner) return

    const slides = Array.from(inner.querySelectorAll('.sp-swiper-slide'))
    if (slides.length === 0) return

    const totalSlides = slides.length
    const slideWidth = 830 + 27 // slide宽度830 + gap27

    // 克隆所有slides到前后，确保左右始终有内容
    // 前面克隆一组，后面克隆两组（确保右边有内容）
    slides.forEach(slide => {
      const cloneBefore = slide.cloneNode(true)
      cloneBefore.classList.add('clone')
      inner.insertBefore(cloneBefore, inner.firstChild)
    })
    for (let i = 0; i < 2; i++) {
      slides.forEach(slide => {
        const cloneAfter = slide.cloneNode(true)
        cloneAfter.classList.add('clone')
        inner.appendChild(cloneAfter)
      })
    }

    let currentIndex = totalSlides // 从真实第一张开始（前面有一组克隆）
    let isTransitioning = false
    let autoPlayTimer = null
    let startX = 0
    let isDragging = false

    // 初始位置
    inner.style.transition = 'none'
    inner.style.transform = `translateX(-${currentIndex * slideWidth}px)`

    // 切换到指定索引
    function goToSlide(index, animate = true) {
      if (isTransitioning && animate) return
      if (animate) isTransitioning = true
      currentIndex = index
      inner.style.transition = animate ? 'transform 0.5s ease' : 'none'
      inner.style.transform = `translateX(-${currentIndex * slideWidth}px)`
      if (!animate) isTransitioning = false
    }

    // 过渡结束后检查是否需要无感跳转
    inner.addEventListener('transitionend', function () {
      isTransitioning = false
      // 如果滚动到后面的克隆区域，无感跳回真实区域
      if (currentIndex >= totalSlides * 2) {
        inner.style.transition = 'none'
        currentIndex = currentIndex - totalSlides
        inner.style.transform = `translateX(-${currentIndex * slideWidth}px)`
      }
      // 如果滚动到前面的克隆区域，无感跳到真实区域
      if (currentIndex < totalSlides) {
        inner.style.transition = 'none'
        currentIndex = currentIndex + totalSlides
        inner.style.transform = `translateX(-${currentIndex * slideWidth}px)`
      }
    })

    // 自动轮播
    function startAutoPlay() {
      stopAutoPlay()
      autoPlayTimer = setInterval(function () {
        if (!isTransitioning && !isDragging) {
          goToSlide(currentIndex + 1)
        }
      }, 3000)
    }

    function stopAutoPlay() {
      if (autoPlayTimer) {
        clearInterval(autoPlayTimer)
        autoPlayTimer = null
      }
    }

    // 手动滑动
    function handleStart(e) {
      if (isTransitioning) return
      isDragging = true
      startX = e.type.includes('mouse') ? e.pageX : e.touches[0].clientX
      stopAutoPlay()
    }

    function handleEnd(e) {
      if (!isDragging) return
      isDragging = false
      const endX = e.type.includes('mouse')
        ? e.pageX
        : e.changedTouches[0].clientX
      const diff = startX - endX

      if (diff > 50) {
        goToSlide(currentIndex + 1)
      } else if (diff < -50) {
        goToSlide(currentIndex - 1)
      }
      startAutoPlay()
    }

    // 绑定事件
    wrapper.addEventListener('mousedown', handleStart)
    wrapper.addEventListener('mouseup', handleEnd)
    wrapper.addEventListener('mouseleave', function () {
      if (isDragging) {
        isDragging = false
        startAutoPlay()
      }
    })
    wrapper.addEventListener('touchstart', handleStart, { passive: true })
    wrapper.addEventListener('touchend', handleEnd)

    // 启动自动轮播
    startAutoPlay()
  }

  // 初始化sp-part2-2轮播图
  initPart2_2Swiper()

  // 移动端sp-part2-2轮播图（无缝循环版本）
  function initPart2_2MobileSwiper() {
    const container = document.querySelector(
      '.sp-part2-2.sp-mobile .sp-swiper-box'
    )
    if (!container) return

    const wrapper = container.querySelector('.sp-swiper-wrapper')
    const inner = wrapper.querySelector('.sp-swiper-inner')
    if (!inner) return

    const slides = inner.querySelectorAll('.sp-swiper-slide')
    const dots = container.querySelectorAll('.sp-swiper-dots .sp-dot')
    if (slides.length === 0) return

    const totalSlides = slides.length
    const slideWidth = 986
    let currentIndex = 0
    let autoPlayTimer = null
    let startX = 0
    let isDragging = false
    let isTransitioning = false

    // 克隆首尾幻灯片实现无缝循环
    const firstClone = slides[0].cloneNode(true)
    const lastClone = slides[totalSlides - 1].cloneNode(true)
    firstClone.classList.add('clone')
    lastClone.classList.add('clone')
    inner.appendChild(firstClone)
    inner.insertBefore(lastClone, slides[0])

    // 初始位置（因为前面插入了克隆，所以从1开始）
    let realIndex = 1
    inner.style.transform = `translateX(-${realIndex * slideWidth}px)`

    // 更新指示器
    function updateDots() {
      dots.forEach((dot, i) => {
        dot.classList.remove('active')
        if (i === currentIndex) {
          dot.classList.add('active')
        }
      })
    }
    updateDots()

    // 切换到指定索引（无缝版本）
    function goToSlide(index) {
      if (isTransitioning) return
      isTransitioning = true

      realIndex = index + 1 // +1因为前面有克隆
      inner.style.transition = 'transform 0.5s ease'
      inner.style.transform = `translateX(-${realIndex * slideWidth}px)`

      // 更新currentIndex用于指示器
      if (index < 0) {
        currentIndex = totalSlides - 1
      } else if (index >= totalSlides) {
        currentIndex = 0
      } else {
        currentIndex = index
      }
      updateDots()
    }

    // 监听过渡结束，处理无缝跳转
    inner.addEventListener('transitionend', function () {
      isTransitioning = false

      // 如果到了克隆的最后一张（实际是第一张的克隆），跳回真正的第一张
      if (realIndex >= totalSlides + 1) {
        inner.style.transition = 'none'
        realIndex = 1
        inner.style.transform = `translateX(-${realIndex * slideWidth}px)`
      }
      // 如果到了克隆的第一张（实际是最后一张的克隆），跳到真正的最后一张
      if (realIndex <= 0) {
        inner.style.transition = 'none'
        realIndex = totalSlides
        inner.style.transform = `translateX(-${realIndex * slideWidth}px)`
      }
    })

    // 自动轮播
    function startAutoPlay() {
      stopAutoPlay()
      autoPlayTimer = setInterval(function () {
        if (!isDragging && !isTransitioning) {
          goToSlide(currentIndex + 1)
        }
      }, 3000)
    }

    function stopAutoPlay() {
      if (autoPlayTimer) {
        clearInterval(autoPlayTimer)
        autoPlayTimer = null
      }
    }

    // 手动滑动
    function handleStart(e) {
      isDragging = true
      startX = e.type.includes('mouse') ? e.pageX : e.touches[0].clientX
      stopAutoPlay()
    }

    function handleEnd(e) {
      if (!isDragging) return
      isDragging = false
      const endX = e.type.includes('mouse')
        ? e.pageX
        : e.changedTouches[0].clientX
      const diff = startX - endX

      if (diff > 50) {
        goToSlide(currentIndex + 1)
      } else if (diff < -50) {
        goToSlide(currentIndex - 1)
      }
      startAutoPlay()
    }

    // 绑定事件
    wrapper.addEventListener('mousedown', handleStart)
    wrapper.addEventListener('mouseup', handleEnd)
    wrapper.addEventListener('mouseleave', function () {
      if (isDragging) {
        isDragging = false
        startAutoPlay()
      }
    })
    wrapper.addEventListener('touchstart', handleStart, { passive: true })
    wrapper.addEventListener('touchend', handleEnd)

    // 点击指示器切换
    dots.forEach((dot, i) => {
      dot.addEventListener('click', function () {
        goToSlide(i)
        stopAutoPlay()
        startAutoPlay()
      })
    })

    // 启动自动轮播
    startAutoPlay()
  }

  // 初始化移动端sp-part2-2轮播图
  initPart2_2MobileSwiper()

  // 移动端套餐价格计算
  function initMobileProductCalc() {
    const mobileProductPart = document.querySelector('.product-part.sp-mobile')
    if (!mobileProductPart) return

    const productBoxes = mobileProductPart.querySelectorAll('.product-box')

    // 各套餐单价（与页面当前金额一致）
    let prods = window.product
    const prices = [
      prods[0].price / 100,
      prods[1].price / 100,
      prods[2].price / 100,
    ]
    const comprices = [
      prods[0].compare_at_price / 100,
      prods[1].compare_at_price / 100,
      prods[2].compare_at_price / 100,
    ]

    productBoxes.forEach((box, index) => {
      const addGroup = box.querySelector('.addGroup')
      if (!addGroup) return

      const reduceBtn = addGroup.querySelector('.sp-reduce')
      const addBtn = addGroup.querySelector('.sp-add')
      const input = addGroup.querySelector('input')
      const priceEl = box.querySelector('.sp-price1')

      if (!reduceBtn || !addBtn || !input || !priceEl) return

      const basePrice = prices[index]
      const originPrice = comprices[index]

      // 更新价格显示
      function updatePrice() {
        const quantity = parseInt(input.value) || 1
        const total = (basePrice * quantity).toFixed(2).replace('.', ',')
        const comtotal = (originPrice * quantity).toFixed(2).replace('.', ',')

        // 保留原价span
        const originalPriceSpan = priceEl.querySelector('.sp-price2')
        const originalPriceHTML = originalPriceSpan
          ? originalPriceSpan.outerHTML
          : ''

        priceEl.innerHTML = '€' + total + originalPriceHTML
      }

      // 减少数量
      reduceBtn.addEventListener('click', function () {
        let val = parseInt(input.value) || 1
        if (val > 1) {
          input.value = val - 1
          updatePrice()
        }
      })

      // 增加数量
      addBtn.addEventListener('click', function () {
        let val = parseInt(input.value) || 1
        if (val < 200) {
          input.value = val + 1
          updatePrice()
        }
      })

      // 输入框变化
      input.addEventListener('change', function () {
        let val = parseInt(input.value) || 1
        if (val < 1) val = 1
        if (val > 200) val = 200
        input.value = val
        updatePrice()
      })
    })
  }

  $('.sp-btn-style').click(function () {
    let num = $(this).siblings('.addGroup').find('input').val()
    num == undefined ? (num = 1) : ''
    let id = $(this).attr('data-id')
    window.location.href = '/cart/' + id + ':' + num
  })

  initMobileProductCalc()

  // PC端套餐价格计算
  function initPCProductCalc() {
    const pcProductPart = document.querySelector('.product-part.sp-pc')
    if (!pcProductPart) return

    const productBoxes = pcProductPart.querySelectorAll('.product-box')

    // PC端第一个套餐单价（与页面当前金额一致）
    const basePrice = 14.99

    productBoxes.forEach((box, index) => {
      const addGroup = box.querySelector('.addGroup')
      if (!addGroup) return

      const reduceBtn = addGroup.querySelector('.sp-reduce')
      const addBtn = addGroup.querySelector('.sp-add')
      const input = addGroup.querySelector('input')
      const priceEl = box.querySelector('.sp-price1')

      if (!reduceBtn || !addBtn || !input || !priceEl) return

      // 更新价格显示
      function updatePrice() {
        const quantity = parseInt(input.value) || 1
        const total = (basePrice * quantity).toFixed(2).replace('.', ',')

        // 保留原价span
        const originalPriceSpan = priceEl.querySelector('.sp-price2')
        const originalPriceHTML = originalPriceSpan
          ? originalPriceSpan.outerHTML
          : ''

        // 保留span id
        const priceSpan = priceEl.querySelector('#sp_price3')
        if (priceSpan) {
          priceSpan.textContent = total
        } else {
          priceEl.innerHTML = '€' + total + originalPriceHTML
        }
      }

      // 减少数量
      reduceBtn.addEventListener('click', function () {
        let val = parseInt(input.value) || 1
        if (val > 1) {
          input.value = val - 1
          updatePrice()
        }
      })

      // 增加数量
      addBtn.addEventListener('click', function () {
        let val = parseInt(input.value) || 1
        if (val < 200) {
          input.value = val + 1
          updatePrice()
        }
      })

      // 输入框变化
      input.addEventListener('change', function () {
        let val = parseInt(input.value) || 1
        if (val < 1) val = 1
        if (val > 200) val = 200
        input.value = val
        updatePrice()
      })
    })
  }

  initPCProductCalc()

  // 顶部文本轮播
  ;(function initTopCarousel() {
    var carousels = document.querySelectorAll('.sp-top-carousel')
    if (carousels.length === 0) return

    carousels.forEach(function (carousel) {
      var items = carousel.querySelectorAll('.sp-top-item')
      if (items.length <= 1) return

      var currentIndex = 0

      setInterval(function () {
        items[currentIndex].classList.remove('active')
        currentIndex = (currentIndex + 1) % items.length
        items[currentIndex].classList.add('active')
      }, 3000)
    })
  })()

  // 移动端底部粘性组件滚动显示
  ;(function initStickyBottom() {
    var stickyBottom = document.querySelector('.sp-sticky-bottom.sp-mobile')
    if (!stickyBottom) return

    var firstScreenHeight = window.innerHeight

    function checkScroll() {
      if (window.scrollY > firstScreenHeight) {
        stickyBottom.classList.add('sp-show')
      } else {
        stickyBottom.classList.remove('sp-show')
      }
    }

    window.addEventListener('scroll', checkScroll)
    checkScroll()
  })()
})
